import { render, staticRenderFns } from "./WordCloudChart.vue?vue&type=template&id=84a7d8c4&scoped=true&"
import script from "./WordCloudChart.vue?vue&type=script&lang=js&"
export * from "./WordCloudChart.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudChart.vue?vue&type=style&index=0&id=84a7d8c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a7d8c4",
  null
  
)

export default component.exports